import { render, staticRenderFns } from "./BlackFridayPopup.vue?vue&type=template&id=0691f071&scoped=true&"
import script from "./BlackFridayPopup.vue?vue&type=script&lang=js&"
export * from "./BlackFridayPopup.vue?vue&type=script&lang=js&"
import style0 from "./BlackFridayPopup.vue?vue&type=style&index=0&id=0691f071&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0691f071",
  null
  
)

export default component.exports